import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import { purifier } from '../../../utils/dom';
import { imageSizeTranslation } from '../../../utils/image';
import { prefix } from '../../../utils/locale';
import { cleanInternalLinks } from '../../../utils/string';
import s from './Image.scss';

const Image = ({ content, attrs = {}, setup, first = false, column = 'full', extraProps = {}, imageWidth = false, lazyLoad = true }) => {
	let classes = [s.image];
	if (attrs.className) classes = [...classes, ...attrs.className.map((c) => s[`image${c}`])];

	let Wrapper = ({ children }) => children;
	const style = {};
	if (attrs.width) style.width = attrs.width;
	if (attrs.align) {
		if (attrs.align === 'center') style.margin = '0 auto';
		if (attrs.align === 'right') style.margin = '0 0 0 auto';
	}
	if (Object.keys(style).length > 0) extraProps.style = style;
	if (attrs?.href) {
		const link = cleanInternalLinks(attrs.href);
		const externalLink = /^(https?|mailto|tel)/.test(link);
		const anchorLink = /^#/.test(link);
		const assetLink = /\..{1,4}$/.test(link.replace(/\?.*$/, ''));

		if (attrs.target || externalLink || assetLink) {
			Wrapper = ({ children }) => (
				<a className={s.imageLink} href={link.replace('&amp;', '&')} target="_blank" rel="noopener noreferrer">
					{ children }
				</a>
			);
		} else if (anchorLink) {
			Wrapper = ({ children }) => (
				<a className={s.imageLink} href={link.replace('&amp;', '&')}>
					{ children }
				</a>
			);
		} else {
			Wrapper = ({ children }) => (
				<Link className={s.imageLink} to={prefix(setup, link || '/')}>
					{ children }
				</Link>
			);
		}
	}

	if (first) lazyLoad = 'eager';

	return (
		<Wrapper>
			<figure className={classes.join(' ')}>
				{ content.image.url && <LazyImage {...imageSizeTranslation(column, content.image, lazyLoad, false, imageWidth)} className={[s.image_image, /\.svg$/.test(content.image.url) ? s.image_image__svg : s.image_image__notSvg]} {...extraProps} /> }
				{ content.caption && <figcaption className={s.image_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
			</figure>
		</Wrapper>
	);
};

export default hot(module)(Image);
